 export function convertDateFormat(dateStr) {
    const [year, month, day] = dateStr.split('-');
    return `${year}-${month}-${day}`;
  }